import { formatPrice as formatPriceBase } from '@/components/common/price-format';
import type { CartLine } from '@/configurations/cart/cart-state';

import { lineQuantity, lineTotal } from './cart-pricing';

/** Format an indicative cart price (2 decimals) following the active locale's symbol placement. */
export function formatPrice(
    amount: number | null,
    currency: string | null,
    locale: string,
): string {
    return formatPriceBase(amount, currency, locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/**
 * A cart line's displayed price. Shows the quantity breakdown
 * (`unit × qty = total`) when the quantity is > 1 and a price exists,
 * otherwise just the amount (or the `—` placeholder when unpriced).
 */
export function formatLinePrice(line: CartLine, locale: string): string {
    const total = formatPrice(lineTotal(line), line.currency, locale);
    const quantity = lineQuantity(line);
    if (line.unitPrice === null || quantity <= 1) return total;
    return `${formatPrice(line.unitPrice, line.currency, locale)} × ${quantity} = ${total}`;
}
